/**
 * Re-Created by SH on 12/7/2019.
 */

import {GameAssets} from "./GameAssets";
import { ILayersConfig } from "@nolimitcity/slot-game/bin/core/stage/ILayersConfig";

import { IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import { LayerScaleOption} from "@nolimitcity/slot-game/bin/core/stage/LayerScaleOption";
import { IFontsConfig} from "@nolimitcity/slot-game/bin/core/resource/font/IFontsConfig";
import { IGameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/IGameConfig";
import { Back, Elastic, Bounce, Ease } from "gsap";
import { IReelEngineConfig } from "@nolimitcity/slot-game/bin/core/engines/reel/engine/IEngine";
import { PunkSymbolData } from "./punkEngine/config/PunkSymbolData";
import { IDeviceDependentConfig } from "@nolimitcity/slot-game/bin/core/useragent/UserAgent";
import { IGameTweakerConfig } from "@nolimitcity/slot-game/bin/dev/tweaker/GameTweaker";
import { GameConfig } from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import { SoundManager } from "./resource/sound/SoundManager";
import { SpinMode } from "@nolimitcity/slot-game/bin/core/gametype/SpinMode";
import { BetWinMode } from "@nolimitcity/slot-game/bin/core/gametype/BetWinMode";
import { IWinRatios } from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import { ZeroBetConfig, zeroBetTypes } from "./zerobet/PunkZeroController";
import { GameMode } from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import { MathHelper } from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import { ISymbolStates } from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";

export class PunkGameConfig implements IGameConfig {

    public static instance:PunkGameConfig = new PunkGameConfig();

    RESOURCES_CONFIG:IResourcesGroupConfig = GameAssets.RESOURCES_GROUPS;

    BROWSER_FPS:number = 30;

    GAME_WIDTH:number = 1280;
    GAME_HEIGHT:number = 720;

    DEFAULT_LAYER_SCALE_OPTION:IDeviceDependentConfig<LayerScaleOption> = {
        desktop : {landscape : LayerScaleOption.FIT_WINDOW},
        mobile : {
            landscape : LayerScaleOption.FIT_WINDOW,
            portrait : LayerScaleOption.REELS_FIT_WINDOW
        }
    };

    // An controller for the Z-layers for created PIXI.containers. Managed by StageManager.
    LAYERS:ILayersConfig = {
        LAYOUT_POINTERS : {name : "layout_pointers"},
        BACKGROUND : {
            name : "background",
            scaleOption : LayerScaleOption.FIT_WINDOW,
            customOptions : {
                frame : {x : 0, y : 0, width : 720, height : 720}
            }
        },
        REEL_BACKGROUND : {name : "reelBackground"},
        REEL : {name : "reel"},
        SYMBOLS : {name : "symbols"},
        SYMBOL_OVERLAY : {name : "symbol_overlay"},
        REEL_OVERLAY : {name : "reel_overlay"},
        FEATURE : {name: "feature"},
        WIN_FRAMES : {name : "winFrames"},
        STICKY : {name : "sticky"},
        BET_LINES : {name : "betLines"},
        POSTER : {name : "poster"},
        BIG_WIN : {name : "bigWin"},
        WIN_COUNT_UP : {name : "winCountUp"},
        FOG : {name : "fog"},
        INTRO : {name : "intro", 
        scaleOption : LayerScaleOption.FIT_WINDOW,
        customOptions : {
            frame : {x : 0, y : 0, width : 720, height : 720}
            }
        },
        BUTTON : {name : "button", scaleOption : LayerScaleOption.FIT_WINDOW},

        TWEAK_MODULE : {name : "tweakModule", scaleOption : LayerScaleOption.FIT_WINDOW}
    };
    
    // Define the Default symbol data in constructor.
    SYMBOL_DATA:PunkSymbolData = new PunkSymbolData({
        // Define what kind of texture it should try to find by standard process for linking to specified states.
        STATES : undefined,//[ ReelSymbolStates.NORMAL , ReelSymbolStates.SPIN, ReelSymbolStates.WIN  ],
        DIM:{
            WIDTH: 110,
            HEIGHT: 180,
            PADDING_X: 0,
            PADDING_Y: 0, 
            SCALE: new PIXI.Point(1,1),
        }
    });

    // **  Reel Config ** //
    REEL_ENGINE_CONFIG:IReelEngineConfig = {
 
        // How many reels.
        REEL_AMOUNT:6,

        // What layer.
        LAYER: this.LAYERS.REEL.name,

        // Default stepDistance. Usually the normal symbolSize.
        STEP_DISTANCE:180,
        // Standard Padding Between All Symbols.
        STEP_DISTANCE_PADDING_Y:0,
        // OverflowSymbols that will be displayed at Top. Minimum 1.
        OVERFLOW_TOP: 1,
        // How many symbols should be displayed as part of the winArea.
        WINDOW_AMOUNT:3,
        // OverflowSymbols that will be displayed at bottom. Minimum 1.
        OVERFLOW_BOTT:1,

        // OverflowOffset on Reeldata from server.
        RESULT_OVERFLOW:1,

        // REEL-Dimensions
        DIM:{
            PADDING_X:6,
            PADDING_Y:0,
            WIDTH: 110,
            HEIGHT: 540,
        },
        // FAST: GameSetting.Quickspin is true.
        // QUICK: Player triggers an QuickStop/QuickStart.

        // Define the duration for specific states.
        DURATION:{
            START:      0.25,
            FAST_START: 0.2,
            QUICK_START: 0.2,
            SPIN:       0.25/5,
            STOP:       0.25,
            FAST_STOP:  0.20,
            QUICK_STOP: 0.15,
            NEAR_WIN:   0.03,
            SPIN_TIME:  0.5,
            QUICK_SPIN_TIME: 0.5,

            NUDGE: 1.6,
            EXPAND: 0.25,
        },
        // Define the delay for specific states.
        DELAY:{
            START:        0.09,
            FAST_START:   0.01,
            QUICK_START:  0.0,
            STOP:         0.30,
            FAST_STOP:    0.15,
            QUICK_STOP:   0.01,
        },
        // Define the Easeing for specific states.
        EASING:{
            START: Back.easeIn.config(1.6),
            QUICK_START: Elastic.easeIn.config(1.25,1),
            STOP: Elastic.easeOut.config(0.8, 0.55),
            START_TEASER: CustomEase.create("teaserStart", "M0,0,C0,0,0.057,-0.003,0.09,-0.012,0.177,-0.037,0.231,-0.065,0.32,-0.092,0.355,-0.103,0.379,-0.106,0.415,-0.109,0.437,-0.111,0.453,-0.109,0.475,-0.106,0.495,-0.102,0.51,-0.099,0.527,-0.089,0.563,-0.069,0.589,-0.047,0.622,-0.022,0.65,0,0.7,0.042,0.776,0.042,0.836,0.042,0.877,0.019,0.9,0,0.942,-0.036,1,0,1,0"),
            QUICK_STOP:  Elastic.easeOut.config(0.8, 0.55),
            EXPAND: Bounce.easeOut,
            NUDGE: CustomEase.create("nudge", "M0,0 C0,0 0.216,0.75 0.3,0.9 0.32,0.936 0.375,0.987 0.4,1 0.46,1.03 0.59,1.022 0.638,1 0.702,0.976 0.772,0.988 0.8,1 0.874,1.03 1,1 1,1"),
        }
    }
    
    REEL_ENGINE_POSITIONS:PIXI.Point[] = [
        // x, y = Size + (Padding * step)
        this.ReelPos( 0, 0), // 1
        this.ReelPos( 1, 0), // 2
        this.ReelPos( 2, 0), // 3
        this.ReelPos( 3, 0), // 4
        this.ReelPos( 4, 0), // 5
        this.ReelPos( 5, 0), // 6
    ];
 
    REEL_SETS:any = this.ReelSetCreation([ "BASE_REELSET", "BONUS_REELSET", "FREESPIN_REELSET","RESPIN_REELSET"]);

    ZERO_BETS:ZeroBetConfig[] = [ 
        {
            type:zeroBetTypes.ZERO_BET,
            modes:[ GameMode.FREESPIN,GameMode.RESPIN]
        },
    ];

    WIN_RATIOS:IWinRatios = {
        normalWin: [
            {
                ratio : 0,
                text : "Tiny Win",
                duration : 0,
            },
            {
                ratio : 1.5,
                text : "Small Win",
                duration : 0.3,
            },
            {
                ratio : 3,
                text : "Medium Win",
                duration : 0.5,
            },
            {
                ratio : 5,
                text : "Large Win",
                duration : 1,
            }
        ],
        bigWin : [
            {
                ratio : 15,
                text : "Big Win",
                duration : 5,
            },
            {
                ratio : 25,
                text : "Super Win",
                duration : 7.5,
            },
            {
                ratio : 50,
                text : "Mega Win",
                duration : 9.5,
            }, 
            {
                ratio : 100,
                text : "Epic Win",
                duration : 12,
            },
            {
                ratio : 175,
                text : "Wicked Win",
                duration : 14,
            },
            {
                ratio : 225,
                text : "Wicked Win",
                duration : 14,
            },
            {
                ratio : 275,
                text : "Wicked Win",
                duration : 14,
            },
            {
                ratio : 400,
                text : "Wicked Win",
                duration : 17,
            },
            {
                ratio : 600,
                text : "Wicked Win",
                duration : 20,
            },
            {
                ratio : 1000,
                text : "Wicked Win",
                duration : 23,
            }
            
        ]
    };

    GAME_TWEAKER_CONFIG:IGameTweakerConfig = {
        layer : this.LAYERS.TWEAK_MODULE.name,
        baseWindowWidth : 400,
        moduleHeight : 32,
        copyAllButtonText : "Copy All",
        buttonSkinIdle : "button",
        buttonSkinOver : "button",
        buttonSkinDown : "button",
        buttonSkinDisabled : "button-disabled"
    };

    // #423
    WIN_BELOW_STAKE: boolean = false;
    private constructor() {
        if(PunkGameConfig.instance) {
            throw new Error("GameConfig.constructor() - Instantiation failed: Singleton.");
        }
        GameConfig.gameConfig = this;
        const soundManager:SoundManager = new SoundManager();
    }

    /* Helper  */
    private ReelPosX(step:number):number{
        return PunkSymbolData.DEFAULT_SYMBOL.DIM.WIDTH * 0.5 + (this.REEL_ENGINE_CONFIG.DIM.PADDING_X + this.REEL_ENGINE_CONFIG.DIM.WIDTH) * step;
    }

    private ReelPosY(step:number):number{
        return PunkSymbolData.DEFAULT_SYMBOL.DIM.HEIGHT * 0.5 + (this.REEL_ENGINE_CONFIG.DIM.PADDING_Y + this.REEL_ENGINE_CONFIG.DIM.HEIGHT)*step;
    }

    private ReelPos(stepX:number, stepY:number):PIXI.Point{
        return new PIXI.Point(this.ReelPosX(stepX), this.ReelPosY(stepY));
    }

    private ReelSetCreation(setType:string[]):any{

        const firstReel:number = 0;
        const lastReel:number = this.REEL_ENGINE_CONFIG.REEL_AMOUNT-1;
        const temp:any = {};
        for(let r:number = 0; r < setType.length ; r++){
            temp[setType[r]] = [];
            for(var i:number = 0; i < this.REEL_ENGINE_CONFIG.REEL_AMOUNT;i++){
                let values:string[] = ["M1", "L1", "L3", "M2", "L2", "M4", "M1", "M3", "L3", "M5","M1", "L1", "L3", "M2", "L2", "M4", "M1", "M3", "L3", "M5","M1", "L1", "L3", "M2", "L2", "M4", "M1", "M3", "L3", "M5","M1", "L1", "L3", "M2", "L2", "M4", "M1", "M3", "L3", "M5","M1", "L1", "L3", "M2", "L2", "M4", "M1", "M3", "L3", "M5","M1", "L1", "L3", "M2", "L2", "M4", "M1", "M3", "L3", "M5"];
                if("BASE_REELSET" == setType[r]){
                    if(i != firstReel && i != lastReel) values.push("W","M","M","M","M","S")
                }
                temp[setType[r]].push(MathHelper.shuffleArray(values));
            }
        }
        return  temp;
    }


    /* --------------  */
    SPIN_MODE: SpinMode;
    BET_WIN_MODE: BetWinMode = BetWinMode.BET_WAY;
    REEL_AREA_POS_X: number;
    REEL_AREA_POS_Y: number;
    REEL_AREA_WIDTH: number;
    REEL_AREA_HEIGHT: number;
    REEL_DISPLAY_POSITIONS= [];
    SYMBOLS_NUM_IN_REEL: [number, number, number, number, number];
    SYMBOL_STATES: ISymbolStates;
    SYMBOL_WIDTH: number;
    SYMBOL_HEIGHT: number;
    SYMBOL_BOTTOM_PADDING: number;
    REEL_SPIN_TIME: number;
    REEL_FAST_SPIN_SPIN_TIME: number;
    MIN_STOPPING_TIME?: number;
    REELS_NUM:number;
    REEL_SPIN_START_SYMBOL_CHANGE_TO_SPIN_STATE_DURATION: number;
    REEL_SPIN_START_SYMBOL_CHANGE_TO_SPIN_STATE_DELAY: number;
    REEL_SPIN_START_EASE: Ease;
    REEL_SPIN_STOP_SYMBOL_CHANGE_FROM_SPIN_STATE_DURATION: number;
    REEL_SPIN_STOP_SYMBOL_CHANGE_FROM_SPIN_STATE_DELAY: number;
    REEL_SPIN_STOP_ELASTIC_CONFIG: [number, number];
    REEL_SPIN_QUICK_STOP_ELASTIC_CONFIG: [number, number];
    REEL_SPIN_START_SPEED: number | number[];
    REEL_SPIN_SPIN_SPEED: number | number[];
    REEL_NEAR_WIN_SPIN_SPEED: number | number[];
    REEL_SPIN_STOP_SPEED: number | number[];
    REEL_SPIN_QUICK_STOP_SPEED: number | number[];
    REEL_STOP_DELAY: number | number[];
    REEL_QUICK_STOP_DELAY: number | number[];
    REEL_NEAR_WIN_STOP_DELAY: number | number[];
    NEW_BET_WHEN_ABORT_WIN_PRESENTATIONS: boolean;
}